import styled from 'styled-components';

import { WarningBasicIcon } from '@genially/icons';

import { GameControlButton } from '../../../../../../../../../../shared/application/components/GameControlButton/GameControlButton';

interface StyledTextProps {
  $isWarning: boolean;
}

export const StyledText = styled(GameControlButton.Text)<StyledTextProps>(
  ({ theme: { color }, $isWarning }) => ({
    color: $isWarning
      ? color.content.warning.contrast()
      : color.content.reversed.default(),
  }),
);

export const StyledWarningIcon = styled(WarningBasicIcon)(
  ({ theme: { color, size } }) => ({
    color: color.content.warning.default(),
    width: size.units(2),
    height: size.units(2),
    minWidth: size.units(2),
    minHeight: size.units(2),
  }),
);

export const Wrapper = styled.div({});
